/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section1_P2Inputs */

const en_about_section1_p2 = /** @type {(inputs: About_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Whether you need to quickly view a large JSON file, format messy API responses, convert JSON to other formats, or compare two documents, PureJSON provides fast, secure, and reliable tools right in your browser.`)
};

const ko_about_section1_p2 = /** @type {(inputs: About_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대용량 JSON 파일을 빠르게 보거나, 지저분한 API 응답을 포맷하거나, JSON을 다른 형식으로 변환하거나, 두 문서를 비교해야 할 때 PureJSON은 브라우저에서 바로 빠르고 안전하며 신뢰할 수 있는 도구를 제공합니다.`)
};

const ja_about_section1_p2 = /** @type {(inputs: About_Section1_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大きなJSONファイルをすばやく表示したり、乱雑なAPIレスポンスをフォーマットしたり、JSONを他の形式に変換したり、2つのドキュメントを比較したりする必要がある場合、PureJSONはブラウザ内で高速、安全、信頼性の高いツールを提供します。`)
};

/**
* | output |
* | --- |
* | "Whether you need to quickly view a large JSON file, format messy API responses, convert JSON to other formats, or compare two documents, PureJSON provides fa..." |
*
* @param {About_Section1_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section1_p2 = /** @type {((inputs?: About_Section1_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section1_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section1_p2(inputs)
	if (locale === "ko") return ko_about_section1_p2(inputs)
	return ja_about_section1_p2(inputs)
});